import React, { memo } from 'react';
import { IconWrapper } from 'src/modules/common/icons/IconWrapper';

export const ThermostatIcon = memo(() => (
  <IconWrapper>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        // eslint-disable-next-line max-len
        d="M11.8 10.35v-.7h4.8v.7h-4.8Zm0-3.7v-.7h7.8v.7h-7.8ZM8.2 19.7c-1.033 0-1.908-.358-2.625-1.075C4.858 17.908 4.5 17.033 4.5 16c0-.667.175-1.292.525-1.875A4.04 4.04 0 0 1 6.5 12.7V6c0-.483.162-.888.487-1.213.325-.325.73-.487 1.213-.487.483 0 .888.162 1.213.487.325.325.487.73.487 1.213v6.7a4.04 4.04 0 0 1 1.475 1.425c.35.583.525 1.208.525 1.875 0 1.033-.358 1.908-1.075 2.625-.717.717-1.592 1.075-2.625 1.075Zm-3-3.7h6c0-.5-.142-.988-.425-1.463-.283-.475-.692-.904-1.225-1.287L9.2 13V6a.968.968 0 0 0-.287-.713A.968.968 0 0 0 8.2 5a.968.968 0 0 0-.712.287A.968.968 0 0 0 7.2 6v7l-.35.25c-.533.383-.942.813-1.225 1.287A2.821 2.821 0 0 0 5.2 16Z"
      />
    </svg>
  </IconWrapper>
));
